<template>
  <v-layout>
    <v-flex xs12 sm6 offset-sm3 dense >
      <v-card>
      
        <v-card-title   class="indigo" xs12>
            <div class="col-12">
            <span class="white--text">
                <v-icon small flat class="orange--text">star</v-icon>&nbsp;
                <strong>{{user.first_name}}  {{user.last_name}}</strong>
                &nbsp;
             <v-chip small class="primary" color="white--text">{{user.active ===1 ?'Active' :'Inactive'}}</v-chip>    
            </span>
            </div>
        </v-card-title>
        <v-card-text>
            <v-layout>
            <v-flex xs6>
            <span class="indigo--text">{{user.companies.name}}</span><br/>
            <span class="grey--text">{{user.email}}</span><br/>
            <span class="grey--text">{{user.mobile}}</span><br/>
              <v-switch  v-if="lock_user" @change=setLock() color="indigo" v-model="lock_user" :label="lock_user==true ? 'Account Locked' : 'Account Un Locked'"></v-switch>
            </v-flex>
            <v-divider></v-divider>
            <v-flex xs6>
            <span class="grey--text text-xs-right">{{user.auth_servers.name}}</span><br>
            <span><small>{{user.ldap_string}}</small></span>
            </v-flex>
            </v-layout>
             <v-divider/>
          
            <v-layout row wrap v-if="user.super_user==1">

                  <v-flex sm9 md9 xs9 > &nbsp;</v-flex>
                 
              <v-flex sm12 md12 xs12 offset-2 justify-center>
               <v-card dense >
                 <v-card-title  class="indigo white--text" style="height:30px;padding:5px;margin-bottom:0px">
                   Companies List
                   </v-card-title>
                   <v-card-text style="padding:0px;margin:0px">
                  <v-list-tile
                  v-for="item in companies"
                  :key="item.name"
                  avatar
                  @click=""
                  >
                <v-list-tile-avatar>
                <v-icon>folder</v-icon>
                </v-list-tile-avatar>

                <v-list-tile-content>
                <v-list-tile-title class="dark--text body-1"><strong>{{ item.name }}</strong></v-list-tile-title>
                </v-list-tile-content>

                <v-list-tile-action>
                 <v-switch @change=setAccess(item) color="indigo" v-model="item.access" :label="item.access==true ? 'Active' : 'Inactive'"></v-switch>
                </v-list-tile-action>
                </v-list-tile>
                 
            </v-card-text>
            </v-card>
            </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs6>
                
              </v-flex>

            </v-layout>
              </v-card-text>
       
        <v-card-actions>
          <v-btn flat color="orange">Revoke</v-btn>
          <v-btn flat color="orange" @click="editItem()">Edit</v-btn>
        </v-card-actions>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import UserModel from '@/api/service/UserService';
import CompanyModel from '@/api/service/CompanyService'
  export default {
    data () {
      return {
        search: '',
        user  : {},
        companies: [],
        loadingTable:false,
        lock_user:false,
        search: '',
        rowsPerPageItems: ['50', '100', '200', '400','All'],
        pagination: {
        descending: true,
          page: 1,
          rowsPerPage: 100,
          sortBy: 'fat',
          totalItems: 0,
          rowsPerPageItems: [1, 2, 4, 8, 16]
        },
         headers: [
          { text: 'Company', value: 'name' },
          { text: 'Active', value: 'active' }
        ],
      }
    },
    created: function() {
      var  $id = this.$route.query.id
      UserModel.findAll({id:$id})
            .then(response => {
                console.log(response)
                this.setUsers(response)                
            }).catch(error => {
                console.log(error)
        }); 
     
    },
    mounted: function(){
        /*var $id = this.$route.query.id
        UserModel.findAll({id:$id})
            .then(response => {
                setUsers(response)                
            }).catch(error => {

        });*/ 
    },
    methods: {
        setAccess($item) {
          var $find=false
          for(var $i in this.user.company_list) {
            if(this.user.company_list[$i].id==$item.id && $find ==false) {
              this.user.company_list[$i].access = $item.access
              $find=true
            }
          }
          if($find==false) {
            if(!this.user.company_list) {
              this.user.company_list=[]
            }
            this.user.company_list.push({
              id:$item.id,name:$item.name,access:$item.access
            })
          }
          UserModel.save(this.user).then(
            response => console.log(response)
          ).catch(error => console.log(error))
        },
        setLock(){
          this.user.lock_user = this.lock_user ? 1 : 0;
           UserModel.save(this.user).then(
            response => console.log(response)
          ).catch(error => console.log(error))
        },
        setUsers($user){
            this.user = $user[0];
            this.lock_user = this.user.lock_user==1 ? true : false
              this.user.user_preferences =JSON.parse(this.user.user_preferences)
            
            if(this.user.company_list) {
                this.user.company_list = JSON.parse(this.user.company_list)
            }
            console.log(this.user)
            CompanyModel.findAll()
            .then(response => 
              this.setCompany(response)
            ).catch(error => 
            console.log(error)
            )
        },
        setCompany($companies) {
          this.companies = $companies;
         var $companyList = this.user.company_list
          for(var $i in this.companies) {
            this.companies[$i].access=false;
            for(var $j in $companyList) {
              if($companyList[$j].id==this.companies[$i].id) {
                this.companies[$i].access = !$companyList[$j].access ? 0 : $companyList[$j].access
              }
            }
          }
        },
        editItem () {
            var $url ='/user/edit/?id='+this.user.id
            this.$router.push($url)
        }
    }

  }
</script>